import { Component } from 'react';
import HoldingLayout from './HoldingLayout';

class ProductComingSoon extends Component {
  constructor(props) {
    super(props);
    this.state = { email: '', submitted: false };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.email) {
      this.setState({ submitted: true });
    }
  };

  render() {
    const { submitted } = this.state;

    return (
      <HoldingLayout>
        <section className="h-page-hero h-page-hero-full">
          <div className="h-hero-bg-pattern" aria-hidden="true" />
          <div className="h-section-inner">
            <a href="/" className="h-back-link">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M13 8H3M3 8L7 4M3 8L7 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
              Back to Home
            </a>
            <div className="h-coming-soon-content">
              <div className="h-coming-soon-icon">
                <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="32" cy="32" r="24" />
                  <circle cx="32" cy="32" r="8" opacity="0.4" />
                  <line x1="32" y1="8" x2="32" y2="14" /><line x1="32" y1="50" x2="32" y2="56" />
                  <line x1="8" y1="32" x2="14" y2="32" /><line x1="50" y1="32" x2="56" y2="32" />
                  <line x1="15" y1="15" x2="19" y2="19" opacity="0.3" />
                  <line x1="45" y1="45" x2="49" y2="49" opacity="0.3" />
                  <line x1="45" y1="15" x2="49" y2="19" opacity="0.3" />
                  <line x1="15" y1="45" x2="19" y2="49" opacity="0.3" />
                </svg>
              </div>
              <span className="h-section-tag">In Development</span>
              <h1 className="h-page-hero-title">Something new is coming</h1>
              <p className="h-page-hero-arabic">قريباً</p>
              <p className="h-page-hero-desc h-coming-soon-desc">
                We are building something that will redefine how Saudi businesses operate.
                A third product is in active development and we cannot wait to share it with you.
              </p>

              {submitted ? (
                <div className="h-coming-soon-confirmed">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <span>We'll notify you when it launches.</span>
                </div>
              ) : (
                <form className="h-coming-soon-form" onSubmit={this.handleSubmit}>
                  <input
                    type="email"
                    placeholder="Enter your email to be notified"
                    className="h-coming-soon-input"
                    value={this.state.email}
                    onChange={(e) => this.setState({ email: e.target.value })}
                    required
                  />
                  <button type="submit" className="h-btn-primary">
                    Notify Me
                  </button>
                </form>
              )}
            </div>
          </div>
        </section>
      </HoldingLayout>
    );
  }
}

export default ProductComingSoon;
